/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TemperatureAmbianteDto } from '../../models/temperature-ambiante-dto';

export interface GetTemperaturesAmbiantes$Params {
  /**
   * dkCodeInstallation
   */
  dkCodeInstallation: string;

  /**
   * dateDebut
   */
  dateDebut?: string;

  /**
   * dateFin
   */
  dateFin?: string;
}

export function getTemperaturesAmbiantes(
  http: HttpClient,
  rootUrl: string,
  params: GetTemperaturesAmbiantes$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<TemperatureAmbianteDto>>> {
  const rb = new RequestBuilder(rootUrl, getTemperaturesAmbiantes.PATH, 'get');
  if (params) {
    rb.query('dkCodeInstallation', params.dkCodeInstallation, {});
    rb.query('dateDebut', params.dateDebut, {});
    rb.query('dateFin', params.dateFin, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TemperatureAmbianteDto>>;
    })
  );
}

getTemperaturesAmbiantes.PATH = '/v1/reportings_p1/t_ambiantes';
